import { render, staticRenderFns } from "./riattivaUtente.vue?vue&type=template&id=9ce95d96&"
import script from "./riattivaUtente.vue?vue&type=script&lang=js&"
export * from "./riattivaUtente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports